


































































































import { Component, Mixins, Prop } from 'vue-property-decorator'

import { successNotificationWrapper } from '../../../../../../../../../../../logic/helpers/NotificationService'
import WindowResizeMixin from '../../../../../../../../../../../logic/helpers/WindowResizeMixin'
import { UseFields } from '../../../../../../../../../../Pi'
import { FieldData } from '../../../../../../../../../../Pi/types'
import { SocketsActionsTypes } from '../../../../../../../../components'
import CustomEditor from '../../../../../../../Editor/CustomEditor'
import ActionNodeAction from '../../../../../Action/logic/Actions'
import ProxyUserInputAction from '../../../../logic/Proxy/actions/ProxyUserInputAction'
import { SendMessageNode } from '../../../../logic/SendMessageNode'
import { SendMessageNodeProps } from '../../../../logic/types'
import UserInputActionsList from './UserInputActionsList.vue'

@Component({
  components: {
    UserInputActionsList,
  }
})
export default class UserInputActionAdditionalSettings extends Mixins<WindowResizeMixin, UseFields>(WindowResizeMixin, UseFields) {
  @Prop() action!: ProxyUserInputAction

  @Prop() nodeProps!: SendMessageNodeProps

  @Prop() nodeSocketsActions!: SocketsActionsTypes

  @Prop() editor!: CustomEditor

  @Prop() node!: SendMessageNode

  isOpen = false

  setFailTryMaxCount(arg: FieldData): FieldData {
    arg.setter = (val) => this.action.setFailTryMaxCount(val)
    return arg
  }

  setPattern(arg: FieldData): FieldData {
    arg.setter = (val) => this.action.setPattern(val)
    return arg
  }

  setNegate(arg: FieldData): FieldData {
    arg.setter = (val) => this.action.setNegate(val)
    return arg
  }

  setInactiveActionTime(arg: FieldData): FieldData {
    arg.setter = (val) => this.action.action.inactive_action.time = val
    return arg
  }

  setActions(actions: Array<ActionNodeAction>): void {
    this.action.setUserInputActions(actions, this.node, this.editor)
    successNotificationWrapper(this.$t('success_alert').toString(), this.$t('setting_user_input_actions_is_successfully').toString())
  }

  get context(): this {
    return this
  }

  get FailTryMaxCountIsExist(): boolean {
    return this.action.action.fail_try_max_count > 0
  }

  switchFailTryMaxCount(arg: FieldData): FieldData {
    arg.setter = (val) => {
      if (val) {
        this.action.setFailTryMaxCount(1)
      } else {
        this.action.setFailTryMaxCount(0)
      }
    }

    return arg
  }
}
